import Header from 'components/_OldDesign/header'
import React, { ReactElement, useEffect, useState } from 'react'
import Content from 'components/_OldDesign/content';
import { filterContent, findContent, findContentByTitle, titleOnly, translate } from 'utils/translate';
import { GetStaticProps } from 'next';
import { be } from 'models/conent';
import { useRouter } from 'next/router';
import ProductHeader from 'components/_OldDesign/productHeader';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowAltCircleLeft,
    faArrowAltCircleRight,
} from '@fortawesome/free-solid-svg-icons';
import style from '../styles/Content.module.scss';
import Link from 'next/link';
import { NextPageWithLayout } from './_app';
import OldLayout from '@components/_OldDesign/OldLayout';
import fetchStrapi from 'lib/fetchStrapi';
import { Lang, useLocale } from '@components/Contexts/LocaleContext';
import FormContact from '@components/shared/FormContact';
import { Button } from '@components/Common';
import { ValueOfMoney } from '@components/eMemo';

export const getStaticProps: GetStaticProps = async () => {
    try {
        const contents = await fetchStrapi('/e-memos');
        
        return {
            props: {
                contents,
            },
        };
    } catch (error) {
        return {
            props: {
                data: JSON.stringify(error),
            },
        };

    }

}

const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 5000, min: 3000 },
        items: 1
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

const imgClass = 'm-auto h-96 xl:h-56 relative z-10';

const graphicEMemoDir = '/images/ememo/Graphic e-Memo';
const graphicEMemoFiles = [
    'Always Online, Effortless Access!',
    'Approval in Just One Click!',
    'Attach Files!',
    'Communicate Instantly with the Comment Box!',
    'No Longer Need the Document?',
    'Reject with a Reason!',
    'Store locally or on Cloud, Access Anywhere!',
];

function getGraphicEMemoImage(title: string): string | undefined {
    const plainTitle = title?.replace(/<[^>]*>/g, ' ').trim();
    const fileName = graphicEMemoFiles.find((name) => plainTitle?.includes(name));
    return fileName && `${graphicEMemoDir}/${encodeURIComponent(`${fileName}.png`)}`;
}

const EmemoPage: NextPageWithLayout<{contents: any}> = ({ contents }) => {
    const {lang, setLang} = useLocale();
    const router = useRouter();
    const [scroll, setScroll] = useState(false);
    useEffect(() => {
        const defaultLocale = (localStorage.getItem('lang') ?? 'th') as Lang;
        setLang(defaultLocale);
    }, [router])

    function scrollToContact() {
        setScroll(!scroll);
    }

    return <>
        <Header content={{ 
            title: 'e-Memo by CODIUM - ระบบจัดการเอกสารและเซ็นอนุมัติออนไลน์', 
            content: 'CODIUM e-Memo ระบบจัดการเอกสารออนไลน์ครบวงจร พร้อม e-Signature เซ็นอนุมัติเอกสารได้ทุกที่ ทุกเวลา สอดคล้องตามข้อกฎหมาย เพิ่มประสิทธิภาพการทำงานขององค์กร',
            image: null, 
        }} />
        {<ProductHeader headerItem={contents?.find((item) => item.name === "Ememo Header")} click={scrollToContact} />}

        <div className="px-24">
            {<Content contents={titleOnly(contents?.find((item) => item.name === "why memo"))} />}
            <div className="grid grid-cols-1 relative xl:grid-cols-4">
                {contents?.find((item) => item.name === "why memo")?.subContent.map((d, i) => <span key={i}>
                    <div className={i % 2 === 1 ? 'mt-12' : ''}>
                        <Content contents={d} />
                    </div>
                    <img src="/images/ememo/bg-content.svg" className={`hidden absolute top-8 z-10 xl:block ${i % 2 === 1 ? 'top-[5rem]' : ''}`} alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย" loading="lazy"/>
                </span>)}
            </div>
        </div>
        <div>
            <Content contents={contents.find((item) => item.name === 'See E-Memo at Work')} />
            <Carousel responsive={responsive} className="mx-16 xl:mx-32">
                {contents.find((item) => item.name === 'See E-Memo at Work').subContent.sort((a, b) => a.id > b.id ? 1 : -1)
                  .map((sub, subIndex) => {
                      return <div key={ subIndex }
                        className="flex flex-wrap sm:flex-nowrap justify-center items-center sm:px-24">
                          <div className="flex-col text-center focus:outline-none relative mx-auto align-self-center w-2/3 sm:w-5/12">
                              <img src={getGraphicEMemoImage(sub.title)}
                                className="mx-auto w-full"
                                alt={sub.title}
                                loading="lazy"/>
                          </div>
                          <div className="flex-col text-center m-auto w-full sm:w-6/12">
                              <h2 className="text-dark-blue mt-12 mb-4 prometo font-bold text-5xl sm:text-4xl md:text-3xl"
                                dangerouslySetInnerHTML={ { __html: translate(sub, 'title', lang) } }/>
                              <h2 className="jamjuree thai-lh text-4xl sm:text-2xl md:text-xl my-5"
                                lang="th" dangerouslySetInnerHTML={ { __html: translate(sub, 'description', lang) } }/>
                                <div className="flex justify-center">
                                    <Button
                                        id="contact-us-ememo"
                                        icon="/icons/speech.svg"
                                        text={lang === 'en' ? 'CONTACT US' : 'ติดต่อเรา'}
                                        className="text-sm border border-white"
                                        onClick={scrollToContact}
                                    />
                                </div>
                          </div>
                      </div>
                  })}
            </Carousel>
        </div>
        <div>
            {/* CONTENT1 */}
            {<Content contents={titleOnly(contents?.find((item) => item.name === "FEATURES").subContent.find((item) => item.type === "title"))} />}
            {/* Desktop */}
            <div className="mb-16 xl:px-24">
                {filterContent(contents, 'Content')?.sort((a, b) => a.id > b.id ? 1 : -1).map((d, i) => <div className={`hidden relative bg-no-repeat ${i % 2 === 0 ? 'bg-left' : 'bg-right'} z-10 bg-left grid-row-2 xl:grid-cols-2 xl:grid pt-4 px-16 mx-4 my-16 xl:h-76`} key={i}>
                    <img src={`${be}${d.image[1]?.url}`} className={`absolute ${i % 2 === 0 ? 'left-0' : 'right-0'} `} alt={d.image[1]?.alternativeText} loading="lazy"/>
                    <div className={`${i % 2 === 0 ? ' xl:block' : 'xl:hidden'}`}>
                        <div className={`h-full  xl:flex`} >
                            <img src={`${be}${d.image[0]?.url}`} className={`${imgClass} ${d.image[0]?.url.includes('svg') ? 'h-72' : ''}`} data-aos="fade-right" data-aos-duration="1000" alt={d.image[0]?.alternativeText} loading="lazy"/>
                        </div>
                    </div>
                    <div className="m-auto"> <Content contents={d} /></div>
                    <div className={`hidden xl:block ${i % 2 === 1 ? '' : 'xl:hidden'}`}>
                        <div className={`h-full bg-no-repeat z-10 bg-center xl:flex`} >
                            <img src={`${be}${d.image[0]?.url}`} className={`${imgClass} ${d.image[0]?.url.includes('svg') ? 'h-72' : ''}`} data-aos="fade-left" data-aos-duration="1000" alt={d.image[0]?.alternativeText} loading="lazy"/>
                        </div>
                    </div>
                </div>)}
            </div>

            {/* Mobile */}
            <div className="lg:grid xl:hidden"> {filterContent(contents, 'Content')?.sort((a, b) => a.id > b.id ? 1 : -1).map((d, i) =>
              <div className="grid grid-row-2 " key={i}>
                <div className={`h-full  bg-no-repeat  z-10 bg-center my-8`}
                     style={{ backgroundImage: `url(${be}${d.image[1]?.url})` }}>
                    <img src={`${be}${d.image[0]?.url}`} className={`${imgClass} ${d.image[0]?.url.includes('svg') ? 'h-84 xl:64' : ''}`} alt={d.image[0]?.alternativeText} loading="lazy"/>
                </div>
                <Content contents={d} />
              </div>)}
            </div>
            {/* CONTENT1 */}

            {/* CAREERS */}
            {/* <div className="flex w-full font-light justify-center  relative text-4xl pt-8 textGrey xl:text-xl xl:my-0 xl:mb-4">
                <div className={`${contents?.textColor ? `text-${contents.textColor}` : style.textSecondary} my-8 relative typing`} >
                    <p>Find out more details</p>
                    <div className={style.titleLine1} data-aos="zoom-in-left" data-aos-delay="1000">
                        <img src="/images/homepage/title-line.svg" alt="CODIUM ผู้ให้บริการซอฟต์แวร์และเทคโนโลยีอย่างชาญฉลาดในยุคดิจิทัล" className=" xl:h-auto" loading="lazy" />
                    </div>
                    <div className={style.titleLine2} data-aos="zoom-in-right" data-aos-delay="1000">
                        <img src="/images/homepage/title-line1.svg" alt="CODIUM ผู้ให้บริการซอฟต์แวร์และเทคโนโลยีอย่างชาญฉลาดในยุคดิจิทัล" className=" xl:h-auto" loading="lazy" />
                    </div>
                </div>
            </div> */}

            {/* <div className={`grid grid-col-1 mt-8 rounded-md  2xl:px-28 ${findContentByTitle(contents, 'Find out more details')?.subContent.length == 1 ? 'px-0 md:px-48 2xl:px-48' : 'xl:grid-cols-2'}`}>
                {findContentByTitle(contents, 'Find out more details')?.subContent.map((item, i) =>
                  <div key={i}
                       className={`relative m-8 xl:m-4 rounded-md cursor-pointer ${style.customGradient}`}
                       data-aos="fade-up">
                    <p className="absolute text-5xl md:text-4xl text-white top-16 left-16 xl:top-8 xl:left-8 xl:text-3xl">
                        { item.title }
                    </p>
                    <img src="/images/career/double.svg" className="absolute top-24 xl:top-16 left-8" alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย" loading="lazy"/>
                    <div className="w-100 flex flex-col justify-center mt-40 md:mt-32 xl:mt-20 pb-8" >
                        <div className={ `grid grid-cols-3 mx-4 gap-x-4 ${style.minH15}` }>
                            <p className={`col-span-2 text-3xl md:text-xl text-white p-8 xl:text-lg font-thin xl:p-4 xl:mt-4 px-12 xl:px-4 leading-snug ${lang ==='th' ? 'thai-lh' : ''}`}>{item.description}</p>
                            <img src={`${be}${item.image[0]?.url}`} alt={item.image[0]?.alternativeText} className="w-60 md:w-44 mt-8" />
                        </div>
                        <div data-aos="fade-down"
                          data-aos-easing="linear"
                          data-aos-duration="350" className={`text-4xl text-white font-light px-4 m-8 sm:my-5 md:-mt-5 2xl:-mt-0 xl:m-4 xl:text-3xl font-bold`}>{item.name}</div>
                    </div>
                </div>)}
            </div>

            <div className="w-full text-center mt-16 md:mt-12 xl:mt-14 mb-24 md:mb-20">
                <Link href='/resources/9-e-memo-e-signature'>
                    <button className="rounded-3xl shadow-lg focus:outline-none">
                        <span className="btn custom-blue-button">
                            { lang === 'th' ? 'ดาวน์โหลด' : 'Download' }
                        </span>
                    </button>
                </Link>
            </div> */}

            {/* Price */}
            <div className="flex w-full font-light justify-center  relative text-4xl pt-8 px-8 textGrey xl:text-xl xl:my-0 xl:mb-4">
                <div className={`${contents?.textColor ? `text-${contents.textColor}` : style.textSecondary} text-center my-8 relative typing`} >
                    <p>{contents.find(item => item.title === 'Find out more details')?.description}</p>
                    <div className={style.titleLine1} data-aos="zoom-in-left" data-aos-delay="1000">
                        <img src="/images/homepage/title-line.svg" alt="CODIUM ผู้ให้บริการซอฟต์แวร์และเทคโนโลยีอย่างชาญฉลาดในยุคดิจิทัล" className=" xl:h-auto" loading="lazy" />
                    </div>
                    <div className={style.titleLine2} data-aos="zoom-in-right" data-aos-delay="1000">
                        <img src="/images/homepage/title-line1.svg" alt="CODIUM ผู้ให้บริการซอฟต์แวร์และเทคโนโลยีอย่างชาญฉลาดในยุคดิจิทัล" className=" xl:h-auto" loading="lazy" />
                    </div>
                </div>
            </div>

            <ValueOfMoney />
            {/* <div className="arrow">
                <div className="p-4 w-4/5 mx-auto overflow-x-scroll price-border">
                    <img src={`${be}${findContent(contents, 'Customer')?.image[0].url}`} className="h-auto mw-500 mx-auto" alt={findContent(contents, 'Customer')?.image[0]?.alternativeText} loading="lazy"/>
                </div>
                <FontAwesomeIcon icon={faArrowAltCircleLeft} className="left-arrow fa-6x bg-white"  aria-hidden="true"/>
                <FontAwesomeIcon icon={faArrowAltCircleRight} className="right-arrow fa-6x bg-white"  aria-hidden="true"/>
            </div> */}

            <div className="w-full text-center mt-16 md:mt-12 xl:mt-14 mb-24 md:mb-20 flex justify-center">
                <Button
                        id="contact-us-ememo"
                        icon="/icons/speech.svg"
                        text={lang === 'en' ? 'CONTACT US' : 'ติดต่อเรา'}
                        className="text-sm border border-white"
                        onClick={scrollToContact}
                    />
            </div>

            {/* FAQ */}
            <div className="hidden xl:block xl:px-24">
                {filterContent(contents, 'FAQ')?.sort((a, b) => a.id > b.id ? 1 : -1).map((d, i) =>
                  <div className={`relative bg-no-repeat m-auto z-10 bg-left grid pt-4 px-16 mx-4 my-8 xl:h-76`} key={i}>
                    {d.type === 'subHeadline' ?
                      <div className="w-full font-normal text-left text-4xl my-16 xl:text-base xl:my-4" data-aos="zoom-in" data-aos-duration="1000">
                        <p className="text-left" dangerouslySetInnerHTML={{ __html: d?.title && d?.description ? translate(d, 'title', lang) : translate(d, 'description', lang) }} >
                        </p>
                      </div>
                      : <div className="m-auto xl:max-w-xl xl:text-left">
                          <Content contents={d} center={false} />
                        </div>}
                  </div>)
                }
            </div>
            {/* Mobile */}
            <div className="xl:hidden"> {contents?.filter((item) => item.name.includes('Q') && item.name !== 'FAQ')?.sort((a, b) => a.id > b.id ? 1 : -1).map((d, i) =>
              <div className="grid grid-row-2 " key={i}>
                  <Content contents={d} />
              </div>)}
            </div>
            {/* FAQ */}

            {/* Customer */}
            {<Content contents={titleOnly(contents?.find((item) => item.name === "Customer"))} />}
            <div className="grid grid-cols-3 xl:grid-cols-5 gap5 xl:px-48">
                {findContent(contents, 'Customer')?.subContent.filter(d => d?.image?.length > 0).map((d, i) =>
                    <div className="p-4" key={i}>
                        <img src={`${be}${d.image[0]?.url}`} alt={d.image[0]?.alternativeText}  className="h-auto w-36 m-auto xl:w-28" data-aos="fade-up" data-aos-duration="1000" data-aos-delay={`${i + 1}00`} loading="lazy"/>
                    </div>
                )}
            </div>
        </div >

        {/* FORMs */}
        <div className="w-full h-fit text-white">
          <FormContact product="EMEMO" event="e-memoFormSubmit" scroll={scroll} customContainer={'Container xxl:mx-auto xxl:px-[6rem]'} />
        </div>

    </ >
}

EmemoPage.getLayout = (page: ReactElement) => {
    return <OldLayout>{page}</OldLayout>;
};


export default EmemoPage;
